// src/app/[lang]/components/LazyPdfViewer.tsx
'use client';

import dynamic from 'next/dynamic';

// Client-side wrapper so the ~580 KB pdfjs / react-pdf-viewer bundle is only fetched when an
// article actually renders a PDF. (A next/dynamic call from the server component
// ArticleContent still pulled the chunk into every article page's script list.)
const PdfViewerComponent = dynamic(() => import('../layouts/PdfViewerComponent'), {
  loading: () => <div className="mt-4 text-gray-500 font-helvetica">Loading PDF…</div>,
  ssr: false,
});

export default function LazyPdfViewer({ pdfUrl }: { pdfUrl: string }) {
  return <PdfViewerComponent pdfUrl={pdfUrl} />;
}
